import React from 'react';
import {
    consultationsWorldEmailLink,
    privacyPolicyLink,
} from '../commons/MessageComponents';

export const CONSENT_LINK_URL_STATUS = {
    VALID: 'VALID',
    INVALID: 'INVALID',
    SUBMITTED: 'SUBMITTED',
    EXPIRED: 'EXPIRED',
};

export const getRetainDeleteOptions = (country) => [
    {
        value: 'Retain',
        label: (
            <div>
                <b>I am interested</b> in being contacted in the future
                regarding participation in the ICP. I understand that I can
                contact the D. E. Shaw group at {consultationsWorldEmailLink} if
                I need to update my contact information or other personal
                information.
            </div>
        ),
    },
    {
        value: 'Delete',
        label: (
            <div>
                <b>I am not interested</b> in being contacted in the future
                regarding participation in the ICP. Please remove my personal
                data from the ICP database. I understand that, in accordance
                with the {privacyPolicyLink(country, 'privacy notice')}, the D.
                E. Shaw group may retain certain personal data to comply with
                applicable legal, contractual, or similar obligations.
            </div>
        ),
    },
];
